import styled from "styled-components";

export const UserSummaryWrapper = styled("div")(() => {
  return {
    position: "relative",
    borderRadius: "1rem",
    backgroundColor: "var(--color-background)",
    zIndex: 1,
    "& .heading-row": {
      padding: "var(--cardPadding) 0",
      "& h3": {
        marginBlock: 0,
        fontWeight: 600,
      },
    },
    "& .employee-information-block": {
      gap: "0.15rem",
      padding: "0 0 var(--cardPadding)",
      "& .employee-information": {
        flexDirection: "column",
        gap: "0.1rem",
        "& span": {
          display: "inline-block",
          width: "100%",
        },
        "@media screen and (min-width: 615px)": {
          flexDirection: "row",
          gap: "calc(var(--flexGap)/1)",
          "& div:nth-of-type(1)": {
            flex: 0.3,
            overflow: "hidden",
          },
          "& div:nth-of-type(2)": {
            flex: 0.7,
            overflow: "hidden",
          },
        },
      },
    },
    "& .user-summary-table": {
      overflow: "auto",
      marginBlockEnd: "var(--cardPadding)",
      marginLeft: "0.5rem",
      width: "calc(100% - 0.5rem)",
      maxWidth: "100%",
      "& th": {},
      "@media screen and (max-width: 615px)": {
        marginLeft: "0",
        width: "100%",
      },
    },
    "& .table-footer": {
      padding: "0 calc(var(--cardPadding) /2)",
      border: "1px solid var(--color-primary-hover)",
      borderRadius: ".5rem",
      "& .table-footer-title": {
        flex: 1,
        "& h3": {
          minWidth: "230px",
        },
      },
      "& .table-footer-value": {
        flex: 1,
        "& h3": {
          minWidth: "230px",
          paddingInlineStart: "calc(var(--cardPadding) /2)",
        },
      },
    },
    "& th": {
      color: "var(--color-primary)",
      background: "var(--color-primary-hover)",
      minWidth: "150px",
      fontSize: "18px",
    },
    "& td": {
      minWidth: "200px",
    },
    "& .net-payable-summary": {
      padding: "0 0 var(--cardPadding) 0",
      "& .net-payable-summary-row": {
        border: "1px solid var(--color-primary-hover)",
        borderRadius: "1rem",
        overflow: "hidden",
        "& .net-payable-description": {
          padding: "calc(var(--cardPadding)/2)",
          overflow: "hidden",
          flex: 0.7,
        },
        "& .net-payable-amount": {
          padding: "calc(var(--cardPadding)/2)",
          overflow: "hidden",
          color: "var(--color-primary)",
          backgroundColor: "var(--color-primary-hover)",
          flex: 0.3,
          textAlign: "center",
          "& h3": {
            fontWeight: 700,
            fontSize: "2rem",
          },
        },
        "@media screen and (max-width: 615px)": {
          flexDirection: "column",
          gap: "0",
        },
      },
    },
    "& .summary-button": {
      position: "relative",
      padding: "0 var(--cardPadding) var(--cardPadding)",
      "& button": {
        overflow: "hidden",
        // padding: "calc(var(--cardPadding)/4) calc(var(--cardPadding)/4)",
      },
    },
  };
});
